import { Loader2 } from "lucide-react";
import React from "react";

const Spinner = ({size = 4}: {size?:number | string}) => {
  return <Loader2 className={`animate-spin h-${size} w-${size} `} />;
};

export default Spinner;
